import unescapedText from 'I18n/utils/unescapedText';
export const objectEngagementsSummaryActionTextParser = action => {
  const translationKey = action.objectType ? `copilotToolkit.streamingMessage.objectEngagementsSummary.${action.objectType}` : 'copilotToolkit.streamingMessage.objectEngagementsSummary.CRM_OBJECT';
  return unescapedText(translationKey);
};